import React, { Component } from "react";
import Swal from "sweetalert2";
import Loading from "../../../views/Loading";
import { Grid, Col, Row } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import { dominio } from "../../../routes_backend/routes.jsx";

class CertificadosCalidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      isLoading: false,

      plantaProduccion: "",
      producto: "",
      catalogoPlantasProductos: [],

      resistencia: "",
      cantidadVendida: "",
      cliente: "",
      nombreProyecto: "",
      direccionProyecto: "",
      nombreAsesor: "",
      correoAsesor: "",

      adjunto: null,
    };
  }

  componentDidMount() {
    this._timer = setInterval(() => this.setState({ now: new Date() }), 1000);
    this.fetchPlantasProductos();
  }

  componentWillUnmount() {
    if (this._timer) clearInterval(this._timer);
  }

  fetchPlantasProductos = async () => {
    try {
      const res = await fetch(`${dominio}/getProductosCertificadosCalidad`);
      const json = await res.json().catch(() => ({}));

      if (!res.ok || json.answer !== "true") {
        throw new Error(json.message || "No se pudo obtener plantas/productos");
      }

      const rows = Array.isArray(json.Rows) ? json.Rows : [];

      this.setState({
        catalogoPlantasProductos: rows,
        plantaProduccion: "",
        producto: "",
      });
    } catch (err) {
      Swal.fire("Error", `No se pudo cargar catálogo: ${err.message}`, "error");
    }
  };

  handlePlantaChange = (e) => {
    const planta = e.target.value;
    this.setState({ plantaProduccion: planta, producto: "" });
  };

  resetForm = () => {
    this.setState((prev) => ({
      now: new Date(),
      isLoading: false,

      plantaProduccion: "",
      producto: "",
      catalogoPlantasProductos: prev.catalogoPlantasProductos,

      resistencia: "",
      cantidadVendida: "",
      cliente: "",
      nombreProyecto: "",
      direccionProyecto: "",
      nombreAsesor: "",
      correoAsesor: "",

      adjunto: null,
    }));
    if (this._fileInput) this._fileInput.value = "";
  };

  getNowLabel = () => {
    const { now } = this.state;
    try {
      return new Intl.DateTimeFormat("es-ES", {
        dateStyle: "full",
        timeStyle: "medium",
      }).format(now);
    } catch {
      return now.toLocaleString();
    }
  };

  toSqlLocalString = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };

  handleChange = (key) => (e) => this.setState({ [key]: e.target.value });

  handleAdjuntoChange = (e) => {
    const file = e.target.files?.[0] || null;
    this.setState({ adjunto: file });
  };

  validar = () => {
    const {
      producto,
      resistencia,
      plantaProduccion,
      cantidadVendida,
      cliente,
      nombreProyecto,
      direccionProyecto,
      nombreAsesor,
      correoAsesor,
      adjunto,
    } = this.state;

    if (!plantaProduccion.trim())
      return Swal.fire("Error", "Planta de producción es requerida.", "error");

    if (!producto.trim()) return Swal.fire("Error", "Producto es requerido.", "error");
    if (!resistencia.trim()) return Swal.fire("Error", "Resistencia es requerida.", "error");
    if (!String(cantidadVendida).trim())
      return Swal.fire("Error", "Cantidad Vendida es requerida.", "error");
    if (!cliente.trim()) return Swal.fire("Error", "Cliente es requerido.", "error");
    if (!nombreProyecto.trim())
      return Swal.fire("Error", "Nombre Proyecto es requerido.", "error");
    if (!direccionProyecto.trim())
      return Swal.fire("Error", "Dirección del proyecto es requerida.", "error");
    if (!nombreAsesor.trim())
      return Swal.fire("Error", "Nombre del asesor es requerido.", "error");
    if (!correoAsesor.trim())
      return Swal.fire("Error", "Correo del asesor es requerido.", "error");

    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correoAsesor.trim());
    if (!emailOk) return Swal.fire("Error", "Correo del asesor no es válido.", "error");

    if (adjunto) {
  const isPdf = adjunto.type === "application/pdf";
  if (!isPdf) {
    Swal.fire("Error", "El adjunto debe ser únicamente PDF.", "error");
    return false;
  }
}
    return true;
  };

  handleGuardar = async (e) => {
    e.preventDefault();
    if (!this.validar()) return;

    const {
      now,
      producto,
      resistencia,
      plantaProduccion,
      cantidadVendida,
      cliente,
      nombreProyecto,
      direccionProyecto,
      nombreAsesor,
      correoAsesor,
      adjunto,
    } = this.state;

    const fechaHoraCreacion = this.toSqlLocalString(now);

    const formData = new FormData();
    formData.append("FechaHoraCreacion", fechaHoraCreacion || "");
    formData.append("Producto", producto.trim());
    formData.append("Resistencia", resistencia.trim());
    formData.append("PlantaProduccion", plantaProduccion.trim());
    formData.append("CantidadVendida", String(cantidadVendida).trim());
    formData.append("Cliente", cliente.trim());
    formData.append("NombreProyecto", nombreProyecto.trim());
    formData.append("DireccionProyecto", direccionProyecto.trim());
    formData.append("NombreAsesor", nombreAsesor.trim());
    formData.append("CorreoAsesor", correoAsesor.trim());
    if (adjunto) formData.append("adjunto", adjunto);

    try {
      this.setState({ isLoading: true });

      const response = await fetch(`${dominio}/postCertificadosCalidad`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json().catch(() => ({}));

      if (response.ok) {
        Swal.fire("Guardado", result.message || "Registro guardado.", "success");
        this.resetForm();
      } else {
        Swal.fire("Error", result.error || result.message || "Error al guardar.", "error");
      }
    } catch (error) {
      Swal.fire("Error", `No se pudo conectar con el servidor: ${error.message}`, "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const {
      isLoading,
      producto,
      resistencia,
      plantaProduccion,
      cantidadVendida,
      cliente,
      nombreProyecto,
      direccionProyecto,
      nombreAsesor,
      correoAsesor,
      adjunto,
      catalogoPlantasProductos,
    } = this.state;

    const fechaHoraLabel = this.getNowLabel();

    const plantasUnicas = Array.from(
      new Set(catalogoPlantasProductos.map((x) => x.Planta).filter(Boolean))
    ).sort();

    const productosFiltrados = Array.from(
      new Set(
        catalogoPlantasProductos
          .filter((x) => x.Planta === plantaProduccion)
          .map((x) => x.Producto)
          .filter(Boolean)
      )
    ).sort();

    return (
      <div className="content" style={style.page}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Solicitud de Certificados de Calidad"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <style>{css}</style>

                    <div style={style.centerWrap}>
                      <div style={style.formCard}>
                        <div style={style.headerRow}>
                          <div>
                            <div style={style.title}>Solicitud de Certificados de Calidad</div>
                            <div style={style.subtitle}>
                              Complete la información y adjunte evidencia si aplica.
                            </div>
                          </div>
                          <div style={style.badge}>{fechaHoraLabel}</div>
                        </div>

                        <form onSubmit={this.handleGuardar}>
                          <div className="ff-grid">
                            {/* Fecha/hora */}
                            <div style={style.field}>
                              <div style={style.label}>Fecha y hora (Actual)</div>
                              <div style={style.readonlyBox}>{fechaHoraLabel}</div>
                            </div>

                            {/* Cantidad Vendida */}
                            <div style={style.field}>
                              <div style={style.label}>Cantidad Vendida</div>
                              <input
                                className="ff-input"
                                type="number"
                                value={cantidadVendida}
                                onChange={this.handleChange("cantidadVendida")}
                                placeholder="Ej. 2500"
                              />
                            </div>

                            {/* Resistencia */}
                            <div style={style.field}>
                              <div style={style.label}>Resistencia</div>
                              <input
                                className="ff-input"
                                type="text"
                                value={resistencia}
                                onChange={this.handleChange("resistencia")}
                                placeholder="Ej. 25"
                              />
                            </div>

                            {/* Planta */}
                            <div style={style.field}>
                              <div style={style.label}>Planta de producción</div>
                              <select
                                className="ff-select"
                                value={plantaProduccion}
                                onChange={this.handlePlantaChange}
                              >
                                <option value="" disabled>
                                  Seleccione planta
                                </option>
                                {plantasUnicas.map((p) => (
                                  <option key={p} value={p}>
                                    {p}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Producto */}
                            <div style={style.field}>
                              <div style={style.label}>Producto</div>
                              <select
                                className="ff-select"
                                value={producto}
                                onChange={this.handleChange("producto")}
                                disabled={!plantaProduccion}
                              >
                                <option value="" disabled>
                                  {plantaProduccion
                                    ? "Seleccione producto"
                                    : "Seleccione planta primero"}
                                </option>
                                {productosFiltrados.map((pr) => (
                                  <option key={pr} value={pr}>
                                    {pr}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Cliente */}
                            <div style={style.field}>
                              <div style={style.label}>Cliente</div>
                              <input
                                className="ff-input"
                                type="text"
                                value={cliente}
                                onChange={this.handleChange("cliente")}
                                placeholder="Ej. Constructora XYZ"
                              />
                            </div>

                            {/* Nombre Proyecto */}
                            <div style={style.field}>
                              <div style={style.label}>Nombre Proyecto</div>
                              <input
                                className="ff-input"
                                type="text"
                                value={nombreProyecto}
                                onChange={this.handleChange("nombreProyecto")}
                                placeholder="Ej. Residenciales..."
                              />
                            </div>

                            {/* Nombre asesor */}
                            <div style={style.field}>
                              <div style={style.label}>Nombre del asesor</div>
                              <input
                                className="ff-input"
                                type="text"
                                value={nombreAsesor}
                                onChange={this.handleChange("nombreAsesor")}
                                placeholder="Ej. Juan Pérez"
                              />
                            </div>

                            {/* Correo asesor */}
                            <div style={style.field}>
                              <div style={style.label}>Correo del Asesor</div>
                              <input
                                className="ff-input"
                                type="email"
                                value={correoAsesor}
                                onChange={this.handleChange("correoAsesor")}
                                placeholder="Ej. asesor@correo.com"
                              />
                            </div>

                            {/* Dirección proyecto */}
                            <div className="ff-span-all" style={style.field}>
                              <div style={style.label}>Dirección</div>
                              <input
                                className="ff-input"
                                type="text"
                                value={direccionProyecto}
                                onChange={this.handleChange("direccionProyecto")}
                                placeholder="Ej. Zona 10, Guatemala"
                              />
                            </div>

                            {/* Adjunto */}
                            {/* Adjunto (solo PDF) */}
<div className="ff-span-all" style={style.field}>
  <div style={style.label}>Adjuntar archivo (PDF)</div>
  <input
    className="ff-input"
    type="file"
    accept="application/pdf"
    onChange={this.handleAdjuntoChange}
    ref={(r) => (this._fileInput = r)}
  />
  <div style={style.helper}>
    {adjunto
      ? `Archivo seleccionado: ${adjunto.name}`
      : "Adjuntar PDF de factura o comprobante de venta POS."}
  </div>
</div>
                          </div>

                          <div style={style.actions}>
                            <button type="submit" className="ff-btnPrimary">
                              Guardar
                            </button>
                            <button
                              type="button"
                              className="ff-btnGhost"
                              onClick={this.resetForm}
                            >
                              Limpiar
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        {isLoading && <Loading />}
      </div>
    );
  }
}

const css = `
  :root{
    --c-primary: #0ea5e9;      /* celeste */
    --c-primary-600: #0284c7;
    --c-border: rgba(15, 23, 42, 0.12);
    --c-text: #0f172a;
    --c-muted: rgba(15, 23, 42, 0.65);
    --c-bg: transparent;       /* ✅ sin fondo */
    --c-surface: rgba(255,255,255,0.92);
    --c-surface2: rgba(255,255,255,0.75);
  }

  .ff-grid{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
  }
  @media (max-width: 1100px){
    .ff-grid{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
  }
  @media (max-width: 768px){
    .ff-grid{ grid-template-columns: 1fr; }
  }
  .ff-span-all{ grid-column: 1 / -1; }

  .ff-input, .ff-select{
    width: 100%;
    padding: 12px 12px;
    border-radius: 10px;
    border: 1px solid var(--c-border);
    background: rgba(255,255,255,0.85);
    color: var(--c-text);
    font-size: 14px;
    transition: box-shadow .15s ease, border-color .15s ease;
  }
  .ff-input::placeholder{ color: rgba(15, 23, 42, 0.45); }

  .ff-input:focus, .ff-select:focus{
    outline: none;
    border-color: rgba(14,165,233,0.65);
    box-shadow: 0 0 0 4px rgba(14,165,233,0.18);
    background: rgba(255,255,255,0.95);
  }

  .ff-select{
    appearance: none;
    background-image:
      linear-gradient(45deg, transparent 50%, rgba(15,23,42,.55) 50%),
      linear-gradient(135deg, rgba(15,23,42,.55) 50%, transparent 50%);
    background-position:
      calc(100% - 18px) 52%,
      calc(100% - 12px) 52%;
    background-size: 6px 6px, 6px 6px;
    background-repeat: no-repeat;
    padding-right: 34px;
  }

  .ff-btnPrimary{
    width: 100%;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid rgba(14,165,233,0.35);
    background: linear-gradient(90deg, rgba(14,165,233,0.95), rgba(2,132,199,0.95));
    color: white;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 10px 20px rgba(2,132,199,0.18);
    transition: transform .08s ease, box-shadow .12s ease, opacity .12s ease;
  }
  .ff-btnPrimary:hover{ opacity: .95; }
  .ff-btnPrimary:active{ transform: translateY(1px); box-shadow: 0 6px 14px rgba(2,132,199,0.16); }

  .ff-btnGhost{
    width: 100%;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid var(--c-border);
    background: rgba(255,255,255,0.75);
    color: var(--c-text);
    font-weight: 800;
    cursor: pointer;
    transition: background .12s ease, border-color .12s ease;
  }
  .ff-btnGhost:hover{ background: rgba(255,255,255,0.9); border-color: rgba(14,165,233,0.30); }
`;

const style = {
  page: {
    background: "transparent", // ✅ sin fondo
  },
  centerWrap: {
    minHeight: "65vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
  },
  formCard: {
    width: "100%",
    maxWidth: "1400px",
    borderRadius: "18px",
    padding: "18px",
    background: "rgba(255,255,255,0.88)",
    border: "1px solid rgba(15, 23, 42, 0.10)",
    boxShadow: "0 18px 55px rgba(2, 8, 23, 0.10)",
    textAlign: "left",
    backdropFilter: "blur(10px)",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "14px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "900",
    color: "#0f172a",
    letterSpacing: "0.2px",
  },
  subtitle: {
    marginTop: "4px",
    fontSize: "13px",
    color: "rgba(15, 23, 42, 0.62)",
  },
  badge: {
    padding: "10px 12px",
    borderRadius: "999px",
    border: "1px solid rgba(14,165,233,0.22)",
    background: "rgba(14,165,233,0.10)",
    color: "rgba(15, 23, 42, 0.75)",
    fontWeight: "800",
    fontSize: "12px",
    whiteSpace: "nowrap",
  },
  field: { marginBottom: "0px" },
  label: {
    fontWeight: "800",
    fontSize: "12px",
    marginBottom: "8px",
    color: "rgba(15, 23, 42, 0.78)",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
  },
  readonlyBox: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px dashed rgba(14,165,233,0.35)",
    background: "rgba(14,165,233,0.06)",
    color: "rgba(15, 23, 42, 0.86)",
    fontSize: "14px",
    fontWeight: "700",
  },
  helper: {
    marginTop: "8px",
    fontSize: "12px",
    color: "rgba(15, 23, 42, 0.55)",
  },
  actions: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginTop: "16px",
  },
};

export default CertificadosCalidad;